/**
 * Texte actionnable — un contrôle remis à plat.
 *
 * Ni police ni taille ici : `base.css` fait déjà hériter `font` au bouton, donc le texte
 * prend la typographie de son contexte (une cellule de tableau, un paragraphe). L'écran
 * garde le droit de dire « cette référence est en chasse fixe » ; il n'a plus à redire ce
 * qu'est un contrôle.
 *
 * Le `display` n'est pas non plus imposé : en ligne dans une phrase, en bloc dans une
 * cellule — c'est une décision de mise en page, donc de l'écran.
 */

.root {
  padding: 0;
  border: 0;
  background: none;
  text-align: start;
  /* Rendu en `<a>` (`render={<Link />}`), le soulignement natif dirait « lien » au repos. */
  text-decoration: none;
  font-weight: var(--weight-semibold);
  color: var(--text-strong);
  cursor: pointer;
}

.root:hover:not(:disabled) {
  color: var(--brand);
  text-decoration: underline;
}

/* Désactivé : ni curseur ni soulignement, mais le texte reste lisible — c'est une donnée
   avant d'être une commande, et l'estomper la rendrait moins lisible qu'elle ne doit. */
.root:disabled {
  cursor: default;
}
